<template>
  <vl-layout>
    <PbsGoBackLink />
    <vl-grid>
      <vl-column width="12" width-xs="12">
        <vl-title tag-name="h1"> {{ $t('productgroup.create.title') }} </vl-title>
      </vl-column>
    </vl-grid>
    <form @submit="onSubmit">
      <ProductGroupFormFields />
      <vl-grid v-vl-spacer:top.medium>
        <vl-action-group v-vl-spacer:bottom.small>
          <vl-button icon="save" :mod-loading="loading" mod-icon-before type="submit"
            >{{ $t('general.save') }}
          </vl-button>
          <vl-button icon="cross" type="button" mod-icon-before mod-secondary mod-error @click="cancel">
            {{ $t('general.cancel') }}
          </vl-button>
        </vl-action-group>
      </vl-grid>
    </form>
  </vl-layout>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useForm } from 'vee-validate';
import { useI18n } from 'vue-i18n';
import { useProductGroupDetailStore } from '../../store/product-group/product-group-detail.store';
import { useProductGroupValidations } from './subcomponents/product-group-validations';
import ProductGroupFormFields from './subcomponents/ProductGroupFormFields.vue';
import PbsGoBackLink from '@/components/PbsGoBackLink.vue';

const { t } = useI18n();
const store = useProductGroupDetailStore();
const router = useRouter();

const { validationSchema } = useProductGroupValidations(t);

const { handleSubmit } = useForm({
  validationSchema,
  initialValues: {
    emails: [],
    productProcessDefinitions: []
  }
});

const loading = computed((): boolean => {
  return store.loading;
});

// Creating and cancelling both end on the search screen, where the new group shows up in the results.
const goToOverview = () => {
  router.push({ name: 'configuration', hash: '#productgroup' });
};

const onSuccess = async (values) => {
  const id = await store.create({
    label: values.label?.trim(),
    description: values.description?.trim(),
    emails: values.emails?.map((email: string) => email?.trim()),
    productProcessDefinitions: values.productProcessDefinitions?.map((member: any) => ({
      productProcessDefinitionId: member.productProcessDefinition?.id,
      switchDependency: !!member.switchDependency
    }))
  });

  if (id) {
    goToOverview();
  }
};

const cancel = () => {
  goToOverview();
};

const onInvalidSubmit = ({ values, errors, results }) => {
  // console.log(values); // current form values
  // console.log(errors); // a map of field names and their first error message
  // console.log(results); // a detailed map of field names and their validation results
};

const onSubmit = handleSubmit(onSuccess, onInvalidSubmit);

defineExpose({ onSubmit });
</script>
